export default __webpack_public_path__ + "static/media/Okay.c3c2a061.mp3";